<script>
import Layout from '@layouts/main'

export default {
  page: {
    title: 'Page timeout',
  },
  components: { Layout },
  methods: {
    homeClick: function() {
      this.$router.push({ name: 'Device State' })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="clearfix">
          <h1 class="float-left display-3 mr-4">Timeout</h1>
          <h4 class="pt-3">Oops! Looks like connection timeout.</h4>
          <p class="text-muted">Check your connected to the Network.</p>
          <b-button class="float-left display-3 mr-4" @click="homeClick">Home</b-button>
          >
        </div>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>
